import TextInput from 'components/atoms/form/TextInput/TextInput'
import ToggleSwitch from 'components/atoms/form/ToggleSwitch/ToggleSwitch'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import {isArrayNotEmpty, isCompletedHotelInfoHistory} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import GroupPolicyService from '../../../../services/GroupPolicyService'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './GroupPolicy.scss'
import {isScandinavianProperty} from "../../../../utilities/FormHelper";

class GroupPolicy extends Component {

    constructor(props) {
        super(props)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

        this.state = {
            hotelCode: getSessionItem(SessionConst.HOTEL_CODE),
            hotelInfo: getSessionItem(SessionConst.HOTEL_INFO),
            hotelCurrency: getSessionItem(SessionConst.HOTEL_CURRENCY),
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    initialValues = {
        isGroups: false,
        isStudentGroups: false,
        isHonorGroupRate: false,
        complimentaryRoom: FormConst.COMPLIMENTARY_ROOM_COUNT_DEFAULT,
        isBusParking: false,
        isBaggageService: false,
        isBaggageServiceMandatory: false,
        cost: 0,
        chargeBasis: '',
        isBreakfast: false,
        breakfastIncludes: ''
    }

    validationSchema = Yup.object().shape({
        complimentaryRoom: Yup.number().when("isGroups", {
            is: true,
            then: Yup.number()
                .required(FormConst.VALIDATION_ERROR_REQUIRED)
                .min(1, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO)
        }),
        chargeBasis: Yup.string().when("isBaggageService", {
            is: true,
            then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        cost: Yup.number().when("isBaggageService", {
            is: true,
            then: Yup.number()
                .required(FormConst.VALIDATION_ERROR_REQUIRED)
                .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)
        }),
        breakfastIncludes: Yup.string().when("isBreakfast", {
            is: true,
            then: Yup.string()
                .required(FormConst.VALIDATION_ERROR_REQUIRED)
        })
    })

    handleSubmit(data) {
        let groupPolicies = []

        if (data.isGroups) {
            let baggagePolicyObj = {}
            if (data.isBaggageService && data.isBaggageServiceMandatory) {
                baggagePolicyObj.amount = data.cost
                baggagePolicyObj.chargeUnit = data.chargeBasis
                baggagePolicyObj.conditions = "MANDATORY"
            } else if (data.isBaggageService && !data.isBaggageServiceMandatory) {
                baggagePolicyObj.amount = data.cost
                baggagePolicyObj.chargeUnit = data.chargeBasis
                baggagePolicyObj.conditions = "AVAILABLE"
            } else {
                baggagePolicyObj.conditions = "NOT_AVAILABLE"
            }

            let breakfastPolicyObj
            if (data.isBreakfast) {
                breakfastPolicyObj = {
                    amenityCode: FormConst.BREAKFAST_AMENITY_MAPPING[data.breakfastIncludes],
                    description: data.breakfastIncludes
                }
            }

            let autoPolicies = ["Social", "Motor Coach"]
            autoPolicies.forEach(autoPolicy => {
                groupPolicies.push({
                    sellableTo18Under: data.isStudentGroups,
                    separateSettlementAccepted: data.isHonorGroupRate,
                    busParking: data.isBusParking,
                    baggagePolicy: baggagePolicyObj,
                    breakfastPolicy: breakfastPolicyObj,
                    groupKind: autoPolicy,
                    complimentaryRoomPolicy: {
                        complimentaryRoomRatio: {
                            complimentaryRooms: "1",
                            paidRooms: data.complimentaryRoom
                        }
                    }
                })
            })
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, groupPolicies: groupPolicies })

        this.setState({
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })

    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            if (isArrayNotEmpty(this.state.hotelInfoCompletedHistory.newEntity.groupPolicies.groupPolicies)){
                let policy = this.state.hotelInfoCompletedHistory.newEntity.groupPolicies.groupPolicies[0];
                let initialValues = {
                    isGroups: true,
                    isStudentGroups: policy.sellableTo18Under,
                    isHonorGroupRate: policy.separateSettlementAccepted,
                    isBusParking: policy.busParking,
                    isBaggageService: policy.baggagePolicy !== undefined && policy.baggagePolicy.conditions !== 'NOT_AVAILABLE',
                    isBaggageServiceMandatory: policy.baggagePolicy.conditions == 'MANDATORY' ? true : false,
                    cost: policy.baggagePolicy.amount || 0.00,
                    chargeBasis: policy.baggagePolicy.chargeUnit,
                    isBreakfast: policy.breakfastPolicy !== undefined,
                    breakfastIncludes: policy.breakfastPolicy !== undefined ? policy.breakfastPolicy.description : '',
                    groupKind: "Social",
                    complimentaryRoom: policy.complimentaryRoomPolicy.complimentaryRoomRatio.paidRooms
                }
                this.setState({
                    error: undefined,
                    isLoading: false,
                    initialValues: initialValues
                });
            } else {
                this.setState({ isLoading: false });
            }
        } else {
            await GroupPolicyService.getGroupPolicy({ hotelCode: this.state.hotelCode })
                .then(response => {
                    if (isArrayNotEmpty(response.groupPolicies)) {
                        let policy = response.groupPolicies[0]
                        let initialValues = {
                            isGroups: true,
                            isStudentGroups: policy.sellableTo18Under,
                            isHonorGroupRate: policy.separateSettlementAccepted,
                            isBusParking: policy.busParking,
                            isBaggageService: policy.baggagePolicy !== undefined && policy.baggagePolicy.conditions !== 'NOT_AVAILABLE',
                            isBaggageServiceMandatory: policy.baggagePolicy.conditions == 'MANDATORY' ? true : false,
                            cost: policy.baggagePolicy.amount || 0.00,
                            chargeBasis: policy.baggagePolicy.chargeUnit,
                            isBreakfast: policy.breakfastPolicy !== undefined,
                            breakfastIncludes: policy.breakfastPolicy !== undefined ? policy.breakfastPolicy.description : '',
                            groupKind: "Social",
                            complimentaryRoom: policy.complimentaryRoomPolicy.complimentaryRoomRatio.paidRooms
                        }
                        this.setState({
                            error: undefined,
                            isLoading: false,
                            initialValues: initialValues
                        });
                    } else {
                        this.setState({ isLoading: false });
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while retrieving Group Policy data'
                    })
                })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_POLICIES_PAGE)
            }
        }
    }

    render() {
        return (
            <div className='group-policy-page'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_POLICIES_PAGE}>Policies</NavLink></li>
                        <li className='breadcrumb-item active' aria-current='page'>Group Policy</li>
                    </ol>
                </nav>
                <p className='group-policy-helper-text'>This section is to submit Group Policy details.</p>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true);
                        this.handleSubmit(data);
                        setSubmitting(false);
                    }}
                    onReset={this.handleReset}>
                    {({ values, isSubmitting, isValid, dirty, handleChange, resetForm }) => (
                        <Form className='group-policy-form-element'>
                            <div className='group-policy-form-fields' >
                                <ToggleSwitch
                                    id='isGroups'
                                    name='isGroups'
                                    label='Does your hotel allow groups?'
                                    checked={values.isGroups}
                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                    value='false'
                                    onChange={handleChange}
                                    isrequired='true' />

                                {
                                    values.isGroups &&
                                    (
                                        <>
                                            <p className='group-policy-title'>Group Policy Information</p>
                                            <p className='group-policy-description'>The following information is required when you participate in Choice Group Programs.</p>
                                            <ToggleSwitch
                                                id='isStudentGroups'
                                                name='isStudentGroups'
                                                checked={values.isStudentGroups}
                                                label='Can rooms be sold to student groups?'
                                                options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                onChange={handleChange}
                                                isrequired='true' />
                                            <ToggleSwitch
                                                id='isHonorGroupRate'
                                                name='isHonorGroupRate'
                                                checked={values.isHonorGroupRate}
                                                label='Will you honor the group rate for groups arriving and paying separately?'
                                                options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                onChange={handleChange}
                                                isrequired='true' />
                                            {
                                                values.isGroups && (
                                                    <>                                                      
                                                        <SelectInput id='complimentaryRoom' name='complimentaryRoom'
                                                            label='How many paid rooms must there be for the group to qualify for one complimentary room?'
                                                            options={FormConst.COMPLEMENTARY_ROOMS_OPTIONS}
                                                            isrequired='true' />
                                                    </>
                                                )
                                            }
                                            <ToggleSwitch
                                                id='isBusParking'
                                                name='isBusParking'
                                                checked={values.isBusParking}
                                                label='Do you provide Bus Parking?'
                                                options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                onChange={handleChange}
                                                isrequired='true' />
                                            <div className='baggage-service-fields'>
                                                <p className='group-policy-title'>Baggage Service</p>
                                                <ToggleSwitch
                                                    id='isBaggageService'
                                                    name='isBaggageService'
                                                    checked={values.isBaggageService}
                                                    label='Do you provide a baggage service?'
                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    onChange={handleChange}
                                                    isrequired='true' />
                                                {
                                                    values.isGroups && values.isBaggageService && (
                                                        <>
                                                            <ToggleSwitch
                                                                id='isBaggageServiceMandatory'
                                                                name='isBaggageServiceMandatory'
                                                                checked={values.isBaggageServiceMandatory}
                                                                label='Is baggage service mandatory?'
                                                                options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                onChange={handleChange}
                                                                isrequired='true' />
                                                            <TextInput
                                                                id='cost'
                                                                name='cost'
                                                                type='number'
                                                                min='0.00'
                                                                step='0.5'
                                                                max='2500'
                                                                placeholder='0.00'
                                                                value={values.cost}
                                                                label={`Baggage service Cost in ${this.state.hotelCurrency}`}
                                                                isrequired='true' />
                                                            <SelectInput id='chargeBasis' name='chargeBasis'
                                                                label='Baggage service Frequency' options={FormConst.GROUP_POLICY_CHARGE_BASIS}
                                                                isrequired='true' />
                                                        </>
                                                    )
                                                }
                                            </div>
                                            <div className='breakfast-fields'>
                                                <p className='group-policy-title'>Breakfast</p>
                                                <ToggleSwitch
                                                    id='isBreakfast'
                                                    name='isBreakfast'
                                                    checked={values.isBreakfast}
                                                    label={'Do you provide breakfast?'}
                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    onChange={handleChange}
                                                    isrequired='true' />
                                                {
                                                    values.isGroups
                                                    && values.isBreakfast
                                                    && <SelectInput id='breakfastIncludes' name='breakfastIncludes' label='Breakfast Includes?'
                                                        options={FormConst.GROUP_POLICY_BREAKFAST_AMENITIES}
                                                        isrequired='true' />
                                                }
                                            </div>
                                        </>

                                    )
                                }

                            </div>
                            <FormFooter
                                form={
                                    {
                                        previous: { title: 'Pet Policy', route: RouteConst.ROUTE_PET_POLICY_PAGE },
                                        next: isScandinavianProperty(this.state.hotelInfo) ?  { title: 'Age Tiers', route: RouteConst.ROUTE_AGE_TIERS_PAGE } : { title: 'Taxes & Charges', route: RouteConst.ROUTE_HOTEL_TAXES_PAGE }
                                    }
                                }
                                isSubmit
                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                resetName={FormConst.RESET_BUTTON_TEXT}
                                onReset={this.handleClearForm}
                                submitDisabled={isSubmitting} />
                            <FormModal
                                id='group-policies-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h6>{this.state.loadingMessage}</h6>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='group-policies-page-reset-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.resetFormData(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='group-policies-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}
// Sample redux dispatch
const mapStateToProps = state => {
    return {
        groupPoliciesResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_GROUP_POLICY_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_GROUP_POLICY_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(GroupPolicy, SideNavEntryMapping.HOTEL_POLICIES))